import { FormInstance } from "antd";
import { LTE } from "Utility/Types/status_identity_get_set";

export const setFields = (lte: LTE, form: FormInstance<any>) => {
  form.setFieldsValue({
    LTE_mode: lte?.config?.mode || "auto",
    LTE_mtu: lte?.config?.mtu || 1500,
    LTE_roaming: lte?.policy?.roaming || false,
    LTE_connect_retry_num: lte?.policy?.connect_retry_num || 3,
    LTE_recovery_down_time: lte?.policy?.recovery?.down_times,
    LTE_recovery_apn_enabled: lte?.policy?.recovery?.recover_apn.enabled || false,
    LTE_recovery_apn_action: lte?.policy?.recovery?.recover_apn.action,
    LTE1_pin_enabled: lte?.sim?.[0]?.pin_enabled || false,
    LTE1_apn1: lte?.sim?.[0]?.apn?.[0]?.apn,
    LTE1_apn1_ipv6_enabled: lte?.sim?.[0]?.apn?.[0]?.ipv6_enabled || false,
    LTE1_apn1_auth: lte?.sim?.[0]?.apn?.[0]?.auth?.type || "none",
    LTE1_apn1_username: lte?.sim?.[0]?.apn?.[0]?.auth?.username,
    LTE1_apn2: lte?.sim?.[0]?.apn?.[1]?.apn,
    LTE1_apn2_ipv6_enabled: lte?.sim?.[0]?.apn?.[1]?.ipv6_enabled || false,
    LTE1_apn2_auth: lte?.sim?.[0]?.apn?.[1]?.auth?.type || "none",
    LTE1_apn2_username: lte?.sim?.[0]?.apn?.[1]?.auth?.username,
    LTE1_ipv6_enabled: lte?.sim?.[0]?.apn?.[0]?.ipv6_enabled || false,
    LTE1_auth: lte?.sim?.[0]?.apn?.[0]?.auth?.type || "none",
    LTE1_username: lte?.sim?.[0]?.apn?.[0]?.auth?.username,
    LTE2_pin_enabled: lte?.sim?.[1]?.pin_enabled || false,
    LTE2_ipv6_enabled: lte?.sim?.[0]?.apn?.[0]?.ipv6_enabled || false,
    LTE2_auth: lte?.sim?.[1]?.apn?.[0]?.auth?.type || "none",
    LTE2_username: lte?.sim?.[1]?.apn?.[0]?.auth?.username,
    LTE1_limit_mbyte: lte?.limit?.[0]?.limit_mbyte,
    LTE1_limit_enabled: lte?.limit?.[0]?.enabled || false,
    LTE1_reset_day: lte?.limit?.[0]?.reset?.day || 31,
    LTE1_reset_hour: lte?.limit?.[0]?.reset?.hour || 23,
    LTE1_reset_minute: lte?.limit?.[0]?.reset?.minute || 0,
    LTE1_reset_second: lte?.limit?.[0]?.reset?.second || 0,
    LTE2_apn1: lte?.sim?.[1]?.apn?.[0]?.apn,
    LTE2_apn1_ipv6_enabled: lte?.sim?.[0]?.apn?.[0]?.ipv6_enabled || false,
    LTE2_apn1_auth: lte?.sim?.[1]?.apn?.[0]?.auth?.type || "none",
    LTE2_apn1_username: lte?.sim?.[1]?.apn?.[0]?.auth?.username,
    LTE2_apn2: lte?.sim?.[1]?.apn?.[1]?.apn,
    LTE2_apn2_ipv6_enabled: lte?.sim?.[0]?.apn?.[1]?.ipv6_enabled || false,
    LTE2_apn2_auth: lte?.sim?.[1]?.apn?.[1]?.auth?.type || "none",
    LTE2_apn2_username: lte?.sim?.[1]?.apn?.[1]?.auth?.username,
    LTE2_limit_mbyte: lte?.limit?.[1]?.limit_mbyte,
    LTE2_limit_enabled: lte?.limit?.[1]?.enabled || false,
    LTE2_reset_day: lte?.limit?.[1]?.reset?.day || 31,
    LTE2_reset_hour: lte?.limit?.[1]?.reset?.hour || 23,
    LTE2_reset_minute: lte?.limit?.[1]?.reset?.minute || 0,
    LTE2_reset_second: lte?.limit?.[1]?.reset?.second || 0,
  });
};

// LTE_mode: lte?.config?.mode || "auto",
// LTE_mtu: lte?.config?.mtu || 1500,
// LTE1_pin_enabled: lte?.sim?.[0]?.pin_enabled || false,
// LTE1_apn1: lte?.sim?.[0]?.apn?.[0]?.apn,
// LTE1_apn1_ipv6_enabled: lte?.sim?.[0]?.apn?.[0]?.ipv6_enabled || false,
// LTE1_apn1_auth: lte?.sim?.[0]?.apn?.[0]?.auth?.type || "none",
// LTE1_apn1_username: lte?.sim?.[0]?.apn?.[0]?.auth?.username,
// LTE1_apn2: lte?.sim?.[0]?.apn?.[1]?.apn,
// LTE1_apn2_ipv6_enabled: lte?.sim?.[0]?.apn?.[1]?.ipv6_enabled || false,
// LTE1_apn2_auth: lte?.sim?.[0]?.apn?.[1]?.auth?.type || "none",
// LTE1_apn2_username: lte?.sim?.[0]?.apn?.[1]?.auth?.username,
// LTE2_pin_enabled: lte?.sim?.[1]?.pin_enabled || false,
// LTE2_apn1: lte?.sim?.[1]?.apn?.[0]?.apn,
// LTE2_apn1_ipv6_enabled: lte?.sim?.[0]?.apn?.[0]?.ipv6_enabled || false,
// LTE2_apn1_auth: lte?.sim?.[1]?.apn?.[0]?.auth?.type || "none",
// LTE2_apn1_username: lte?.sim?.[1]?.apn?.[0]?.auth?.username,
// LTE2_apn2: lte?.sim?.[1]?.apn?.[1]?.apn,
// LTE2_apn2_ipv6_enabled: lte?.sim?.[0]?.apn?.[1]?.ipv6_enabled || false,
// LTE2_apn2_auth: lte?.sim?.[1]?.apn?.[1]?.auth?.type || "none",
// LTE2_apn2_username: lte?.sim?.[1]?.apn?.[1]?.auth?.username, //
// LTE1_limit_mbyte: lte?.limit?.[0]?.limit_mbyte,
// LTE1_limit_enabled: lte?.limit?.[0]?.enabled || false,
// LTE1_reset_day: lte?.limit?.[0]?.reset?.day || 31,
// LTE1_reset_hour: lte?.limit?.[0]?.reset?.hour || 23,
// LTE1_reset_minute: lte?.limit?.[0]?.reset?.minute || 0,
// LTE1_reset_second: lte?.limit?.[0]?.reset?.second || 0,
// LTE2_limit_mbyte: lte?.limit?.[1]?.limit_mbyte,
// LTE2_limit_enabled: lte?.limit?.[1]?.enabled || false,
// LTE2_reset_day: lte?.limit?.[1]?.reset?.day || 31,
// LTE2_reset_hour: lte?.limit?.[1]?.reset?.hour || 23,
// LTE2_reset_minute: lte?.limit?.[1]?.reset?.minute || 0,
// LTE2_reset_second: lte?.limit?.[1]?.reset?.second || 0,
// LTE_roaming: lte?.policy?.roaming || false,
// LTE_connect_retry_num: lte?.policy?.connect_retry_num || 3,
